(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/quick-transaction/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/accountservices/quick-transaction/assets/javascripts/prescript.js');
"use strict";


svs = svs || {};
svs.accountservices = svs.accountservices || {};
svs.accountservices.quick_transaction = svs.accountservices.quick_transaction || {};

 })(window);